import { useMutation, useQueryClient } from 'react-query';
import request from '../../../helpers/request';
import { queryKeys } from '../queries/queryKeys';
import { fetchDocumentFilters } from '../store/actions/documentFilter/documentFilterActions';
import { useDispatch } from 'react-redux';

const onSaveDocumentsFilter = async (data) => {
  const { id, ...dataCreate } = data;

  if (!!id) {
    return await request.put(
      `/Filter`,
      data,
      'При сохранении фильтра произошла ошибка',
      'Error'
    );
  }

  return await request.post(
    `/Filter`,
    dataCreate,
    'При сохранении фильтра произошла ошибка',
    'Error'
  );
};

const useSaveDocumentsFilter = () => {
  const queryClient = useQueryClient();

  const dispatch = useDispatch();

  const mutation = useMutation(onSaveDocumentsFilter, {
    onSuccess: (data) => {
      if (data === 'Error') return;

      if (data.success) {
        queryClient.invalidateQueries(queryKeys.savedFilters());
        dispatch(fetchDocumentFilters());
      }
    },
  });

  return {
    isSaveDocumentsFilterLoading: mutation.isLoading,
    onSaveDocumentsFilter: mutation.mutateAsync,
  };
};

export default useSaveDocumentsFilter;
